import MonitoringQueueEntryClientDetailsTable from './MonitoringQueueEntryClientDetailsTable';

export default MonitoringQueueEntryClientDetailsTable;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/client/client-details-table/index.js